import { useEstimateStore, useProjectStore } from '@talon/web/src/context';
import { Box, Button, Layer, Text } from 'grommet';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { TalonInput } from '..';
import { Loader } from '../Loader';

export interface ICreateEstimateModalProps {
  creating: boolean;
  setCreating: (creating: boolean) => void;
  setShowModal: (isVisible: boolean) => void;
}

export const CreateEstimateModal = observer(({ creating, setCreating, setShowModal }: ICreateEstimateModalProps) => {
  /** Context **/
  const projectStore = useProjectStore();
  const estimateStore = useEstimateStore();

  /** State **/
  const [title, setTitle] = useState('New Estimate');

  /** Methods **/

  const createEstimate = async (title: string) => {
    if (!projectStore.currentProject?.id) {
      toast.warn('Select a project to create a new Estimate.');
      return;
    }

    setCreating(true);
    try {
      const newEstimate = await estimateStore.createEstimate(projectStore.currentProject.id, title);
      const estimate = await estimateStore.getEstimate(newEstimate?.id, 'session_estimates,usage_estimates');

      if (estimate) {
        estimateStore.setCurrentEstimate(estimate);
        toast.success('Estimate created');
        setShowModal(false);
      } else {
        toast.error('There was an error creating the Estimate. Please try again in a moment.');
      }
    } catch (err) {
      toast.error('There was an error creating the Estimate. Please try again in a moment.');
    } finally {
      setCreating(false);
    }
  };

  /** Render **/
  return (
    <Layer
      onEsc={() => setShowModal(false)}
      onClickOutside={() => setShowModal(false)}
      position="center"
      modal={true}
      margin="large"
    >
      {creating && <Loader />}
      {!creating && (
        <Box
          direction="column"
          align="start"
          pad="small"
          justify="around"
          width="medium"
          height="medium"
          background="light-1"
          round="small"
        >
          <Box direction="row" pad="small" gap="small" align="center" fill="horizontal">
            <Box width="20%">
              <Text>Title:</Text>
            </Box>
            <Box fill="horizontal">
              <TalonInput val={title || ''} onChange={(val) => setTitle(val)} plain={false} />
            </Box>
          </Box>
          <Button
            pad="small"
            margin="small"
            hoverIndicator
            disabled={creating}
            onClick={() => createEstimate(title)}
            label={creating ? 'Creating...' : 'Create Estimate'}
          />
        </Box>
      )}
    </Layer>
  );
});
